import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiService } from '../service/Api';
import toast from 'react-hot-toast';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const hasHandledRef = useRef(false);

// `http://localhost:3000?token=${encodeURIComponent(sessionToken)}&user=${encodeURIComponent(JSON.stringify({id: user.data.id, email: user.data.email, name: user.data.name}))}`;


  useEffect(() => {
    const handleAuthCallback = async () => {
      if (hasHandledRef.current) {
        return;
      }
      hasHandledRef.current = true;

      const token = searchParams.get('token');
      const tenantId = searchParams.get('tenant_id');
      const hs_url = searchParams.get('url');
      const error = searchParams.get('error');
    
      const redirect_url = searchParams.get('redirect_url');
      if (error) {
        toast.error('Authentication failed');
        navigate('/login');
        return;
      }

      if (token) {
        try {
          console.log("token", token);
          console.log("tenant_id", tenantId);
          
          // CRITICAL: Set tenant_id FIRST before token, as verifyAuth requires both headers
          // Store tenant_id if provided
          if (tenantId) {
            localStorage.setItem('aura_tenant_id', tenantId);
            apiService.setTenantId(tenantId);
            console.log("Tenant ID stored and set:", tenantId);
          } else {
            console.warn("No tenant_id provided in callback URL - verifyAuth may fail");
          }
          
          // Store token in localStorage and set in API service headers
          localStorage.setItem('aura_token', token);
          apiService.setAuthToken(token);
          console.log("Token stored and set in headers");
          
          // Get user data and account domain - verifyAuth requires both token and tenant_id headers
          console.log("Calling verifyAuth...");
          const userResponse = await apiService.verifyAuth();
          console.log("verifyAuth response:", userResponse);
          
          if (userResponse.data.valid) {
            console.log("userResponse", userResponse);
            const userData = userResponse.data.user;
            login(token, userData);
          if(redirect_url){
            // Extract path from full URL if it's a complete URL
            try {
              const url = new URL(redirect_url);
              navigate(url.pathname + url.search + url.hash);
            } catch {
              // If it's not a valid URL, assume it's already a path
              navigate(redirect_url);
            }
          }else{
            navigate('/tailspin/dashboard');
            // Extract account domain from user's email or company info
           // navigate(`/?url=${url}`);
            // opem a new tab with the url
          }
            // Only open a new tab if hs_url is provided
            if (hs_url) {
              const urlToOpen = `${hs_url}?open=true`
              window.open(urlToOpen);
            }
            
            // Notify extension if running in iframe
         
          }
        } catch (error) {
          console.error('Login error:', error);
          console.error('Error details:', error.response?.data || error.message);
          
          // Clear any partial auth data on error
          localStorage.removeItem('aura_token');
          localStorage.removeItem('aura_tenant_id');
          apiService.setAuthToken(null);
          apiService.setTenantId(null);
          
          toast.error('Authentication failed: ' + (error.response?.data?.error || error.message));
          navigate('/login');
        }
      } else {
        toast.error('No authentication token received');
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [searchParams, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="spinner mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Completing Authentication...
        </h2>
        <p className="text-gray-600">
          Please wait while we set up your account.
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;